import { toast } from 'react-toastify';
import { httpsCallable } from "firebase/functions";
import { functions } from '../../firebase.config';
import { fetchValidUSPSToken } from './fetchValidUSPSToken';
import { calculatePackageDimensions } from './calculatePackageDimensions';


const fetchShippingPrice = async (email, shippingAddress, cartItems) => {

    if (cartItems.length <= 0) {
        toast.error("Your cart is empty. Please add items to your cart before proceeding to checkout.");
        return;
    }

    if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        toast.error("Please enter a valid email address.");
        return;
    }
    if (!shippingAddress.phone || shippingAddress.phone.length < 10) {
        toast.error("Please enter a valid phone number.");
        return;
    }
    if (!shippingAddress.fullName || shippingAddress.fullName.length <= 2) {
        toast.error("Please enter your full name.");
        return;
    }
    if (
        !shippingAddress.city || shippingAddress.city.length < 2 ||
        !shippingAddress.street || shippingAddress.street.length <= 2 ||
        !shippingAddress.state || shippingAddress.state.length < 2 ||
        !shippingAddress.zip || (shippingAddress.zip < 2)
    ) {
        toast.error("Invalid address. Please check your street, state, and ZIP code.");
        return;
    }



    try {
        // Get USPS access token
        const accessToken = await fetchValidUSPSToken();
        const dimensions = await calculatePackageDimensions(cartItems);
        const weightInOunces = cartItems.reduce((acc, item) => acc + (item.weight * item.quantity), 0);
        const weightInPounds = weightInOunces / 16;

        let validatedAddress = shippingAddress;

        // Validate the address first
        if (shippingAddress.country && shippingAddress.country == 'US') {
            const validateAddress = httpsCallable(functions, "validateAddress");
            const validatedAddressResult = await validateAddress({
                accessToken: accessToken,
                streetAddress: shippingAddress.street,
                city: shippingAddress.city,
                state: shippingAddress.state,
                zipCode: shippingAddress.zip,
            });
            if (!validatedAddressResult.data || !validatedAddressResult.data.address.ZIPCode) {
                toast.error("Invalid address! Please enter a valid address.");
                return;
            }
            validatedAddress = validatedAddressResult.data.address;
        }        

        // Extract ZIP and ZIP+4
        const zipCode = validatedAddress?.ZIPCode || validatedAddress.zip;
        const zipPlus4 = validatedAddress?.ZIPPlus4 || null;

        if (shippingAddress.country === 'US' &&  !zipPlus4) {
            toast.error("Please provide a valid US address");
            return;
        }        

        const url =
            shippingAddress.country === "US"
                ? process.env.REACT_APP_DOMESTIC_SHIPPING_RATE_URL
                : process.env.REACT_APP_INTERNATIONAL_SHIPPING_RATE_URL;        

        const response = await fetch(
            url,
            {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    accessToken: accessToken,
                    destinationZIPCode: zipCode,
                    destinationCountryCode: shippingAddress.country,
                    weight: weightInPounds + dimensions.weight,
                    length: dimensions.length,
                    width: dimensions.width,
                    height: dimensions.height,
                }),
            }
        );

        console.log('Shipping price fetch response status:', response.status);

        if (response.status === 401) {
            console.warn("🚨 Invalid USPS token, refetching...");
            localStorage.removeItem('uspsAccessToken');
            localStorage.removeItem('uspsTokenExpiry');
            const newToken = await fetchValidUSPSToken();

            // retry once with the new token
            return await fetch(url, {
                method: "POST",
                headers: { Authorization: `Bearer ${newToken}` },
                body: JSON.stringify({
                    accessToken: accessToken,
                    destinationZIPCode: zipCode,
                    destinationCountryCode: shippingAddress.country,
                    weight: weightInPounds + dimensions.weight,
                    length: dimensions.length,
                    width: dimensions.width,
                    height: dimensions.height,
                }),
            });
        }

        if (!response.ok) {
            toast.error("Invalid address! Check your address and retry.");
            return;
        }

        const shippingCost = await response.json();
        toast.success("Shipping information added successfully!")
        
        return {
            shippingPrice: shippingCost.shippingPrice,
            zipPlus4,
            dimensions
        };

    } catch (error) {
        toast.error("Error fetching shipping price.");
        console.log(error)
        return;
    }
};

export default fetchShippingPrice;